import * as React from "react"
import { cn } from "../../lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const inputRef = React.useRef(null);
  
  const inputClassName = cn(
    "flex h-10 w-full rounded-md border bg-[#262624] px-3 py-2 text-sm text-[#fcce9b] border-[#fcb463] ring-offset-[#262624] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#fcce9b] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#fcb463] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
    type === "number" && "pr-8 appearance-none",
    className
  )

  const increment = () => {
    if (inputRef.current) {
      inputRef.current.stepUp();
      inputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  const decrement = () => {
    if (inputRef.current) {
      inputRef.current.stepDown();
      inputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (type === "number") {
    return (
      <div className="relative group">
        <input
          type={type}
          className={inputClassName}
          ref={(node) => {
            inputRef.current = node;
            if (typeof ref === 'function') {
              ref(node);
            } else if (ref) {
              ref.current = node;
            }
          }}
          {...props}
        />
        <div className="absolute right-[5px] top-1 bottom-1 w-6 flex flex-col opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            type="button"
            className="flex-1 flex items-center justify-center text-[#fcb463] hover:text-[#fca443]"
            onClick={increment}
          >
            <span className="text-[0.6rem] leading-none">▲</span>
          </button>
          <button
            type="button"
            className="flex-1 flex items-center justify-center text-[#fcb463] hover:text-[#fca443]"
            onClick={decrement}
          >
            <span className="text-[0.6rem] leading-none">▼</span>
          </button>
        </div>
        <style jsx>{`
          input[type="number"]::-webkit-inner-spin-button,
          input[type="number"]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
          input[type="number"] {
            -moz-appearance: textfield;
          }
        `}</style>
      </div>
    )
  }

  return (
    <input
      type={type}
      className={inputClassName}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }